<div class="pos-relative"
     [class.is-required]="required"
     [class.is-disabled]="disabled"
     [class.is-invalid]="!validation.isHidden">
    @if (label) {
    <label class="label">{{label}}</label>
    }
    <ng-content />
    <validation [messages]="messages"
                [canShow]="canShowValidate"
                #validation />
</div>